import { render, staticRenderFns } from "./BioBreakEndPrompt.vue?vue&type=template&id=6a28368e&"
import script from "./BioBreakEndPrompt.vue?vue&type=script&lang=js&"
export * from "./BioBreakEndPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports